import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from './logger';

export class ConsoleLogger implements LoggerService {
  log(obj: any): void {
    if (obj instanceof HttpErrorResponse) {
      console.log(obj.message);
    } else if (obj['toLowerCase']) {
      console.log(obj);
    } else {
      console.log('Undefined error');
    }
  }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/console-logger.service.ts